import { ReactNode } from 'react';
import { useFieldContext } from './formHooks';
import {
  Field,
  FieldContent,
  FieldDescription,
  FieldError,
  FieldLabel,
} from '../ui/field';
import { InfoPopover } from '@/components/ui/info';

export type FormControlProps = {
  label?: string;
  description?: string;
  className?: string;
  disabled?: boolean;
  isRequired?: boolean;
  infoText?: string;
};

type FormBaseProps = FormControlProps & {
  children: ReactNode;
  horizontal?: boolean;
  controlFirst?: boolean;
};

// eslint-disable-next-line complexity, max-lines-per-function
export function FieldBase({
  children,
  label,
  isRequired,
  description,
  controlFirst,
  horizontal,
  infoText,
  className,
}: FormBaseProps) {
  const field = useFieldContext();
  const isInvalid = !field.state.meta.isValid;
  const labelElement = (
    <>
      <FieldLabel htmlFor={field.name}>
        <div>
          {`${label}${isRequired ? '*' : ''}`}

          {infoText && (
            <InfoPopover
              text={infoText}
              iconAriaLabel={`Info ${field.name}`}
              className="ml-1"
            />
          )}
        </div>
      </FieldLabel>
      {description && <FieldDescription>{description}</FieldDescription>}
    </>
  );
  const errorElement = isInvalid && (
    <FieldError errors={field.state.meta.errors} />
  );

  return (
    <Field
      data-invalid={isInvalid}
      className={className}
      orientation={horizontal ? 'horizontal' : undefined}>
      {controlFirst ? (
        <>
          {children}
          <FieldContent>
            {labelElement}
            {errorElement}
          </FieldContent>
        </>
      ) : (
        <>
          <FieldContent>{labelElement}</FieldContent>
          {children}
          {errorElement}
        </>
      )}
    </Field>
  );
}
